import { JetView } from 'webix-jet';
import { countries, devConfig, profile } from 'config/config';

/**
 * Class representing the FilterBalanceHistoryView.
 * Extends JetView to create a specific view for filtering balance history.
 */
export default class FilterBalanceHistoryView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'UserId',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // User ID label
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'), // Placeholder for input
                        },
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'), // Datepicker label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for input
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Date label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for input
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Country selection label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for input
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Custom template for country options
                                        );
                                    },
                                    data: countries, // Country data source
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByCountry',
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'BetShopOwn',
                            label: _('Punto de venta propio?'), // Own sales point label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for input
                            options: [
                                { id: 'S', value: _('Si') }, // Yes option
                                { id: 'N', value: _('No') }, // No option
                            ],
                        },
                        {
                            view: 'radio',
                            name: 'Type',
                            id: 'Type',
                            label: _('Tipo'), // Type label
                            labelPosition: 'top',
                            value: 1, // Default selected value
                            options: [
                                { id: 1, value: _('Totales') }, // Total option
                                { id: 0, value: _('Detallado') }, // Detailed option
                            ],
                        },
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 260 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button',
                            value: _('Limpiar'), // Clear button label
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200,
                            click: () => {
                                $$('myForm').setValues($$('myForm').getCleanValues()); // Clear form values
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'), // Consult button label
                            hotkey: 'enter', // Hotkey for button
                            type: 'form',
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove Date if typeDate is not 2
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                                    }
                                }
                                this.app.callEvent('balanceHistory:filter', [filterdata]); // Trigger filter event
                                $$('b5').collapse(); // Collapse the accordion
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Accordion header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form',
            id: 'myForm', // Form ID
            type: 'clean',
            rows: [accordion_section], // Main layout
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide gravity element on small screens
            }
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date if typeDate is 2
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });

        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
